// src/Components/BotAssistant.js
import React, { useEffect, useRef, useState } from "react";
import lottie from "lottie-web";

const BotAssistant = ({ voiceFile, show }) => {
  const container = useRef(null);
  const audioRef = useRef(null);
  const [isAudioUnlocked, setIsAudioUnlocked] = useState(false);

  useEffect(() => {
    if (container.current) {
      const anim = lottie.loadAnimation({
        container: container.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: process.env.PUBLIC_URL + "/finhubBotDesign/robo.json",
      });
      return () => anim.destroy();
    }
  }, []);

  useEffect(() => {
    const unlockAudio = () => {
      setIsAudioUnlocked(true);
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
    };

    document.addEventListener("click", unlockAudio);
    document.addEventListener("keydown", unlockAudio);

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
    };
  }, []);

  useEffect(() => {
    if (isAudioUnlocked && voiceFile && audioRef.current) {
      audioRef.current.src = voiceFile;
      audioRef.current.play().catch((err) => {
        console.log("Autoplay blocked:", err);
      });
    }
  }, [voiceFile, isAudioUnlocked]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "10px",
        left: "10px",
        width: "120px",
        height: "120px",
        zIndex: 1000,
      }}
    >
      <div ref={container} style={{ width: "100%", height: "100%" }} />
      <audio ref={audioRef} />
    </div>
  );
};

export default BotAssistant;
